import {
  DIALOGUES_ITERATIONS,
  DIALOGUES_MARKETING_CONFIG,
  DIALOGUES_PROGRAM_DETAILS,
} from '@/client/services/dialogues/config'
import { KA_LEARNING_LABS_EMAIL_DATA } from '@/client/services/programs/ka-learning-labs/constants'
import {
  SAT_BOOTCAMP_MARKETING_CONFIG,
  SAT_BOOTCAMP_PROGRAM_DETAILS,
} from '@/client/services/satBootcamp/constants'

import {
  CAW_EMAIL_DATA,
  CAW_ITERATIONS,
  CAW_MARKETING_CONFIG,
  CAW_PROGRAM_DETAILS,
} from '../collegeAdmissionsWorkshops/constants'
import type { ProgramSubworldSlug } from '../worlds/types'
import {
  ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG,
  COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG,
  DIALOGUES_PROGRAM_SLUG,
  PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG,
  type ProgramSlug,
  type ProgramSlugWithIterations,
  SAT_BOOTCAMP_PROGRAM_SLUG,
} from './constants'
import {
  ALGEBRA2_LEARNING_LABS_ITERATIONS,
  ALGEBRA2_LEARNING_LABS_MARKETING_CONFIG,
  ALGEBRA2_LEARNING_LABS_PROGRAM_DETAILS,
} from './ka-learning-labs/algebra2/constants'
import {
  PRE_CALCULUS_LEARNING_LABS_ITERATIONS,
  PRE_CALCULUS_LEARNING_LABS_MARKETING_CONFIG,
  PRE_CALCULUS_LEARNING_LABS_PROGRAM_DETAILS,
} from './ka-learning-labs/pre-calculus/constants'
import type {
  ProgramDetails,
  ProgramEmailData,
  ProgramIteration,
  ProgramMarketingConfig,
} from './types'

export const PROGRAM_SLUG_TO_PROGRAM_DETAILS: Record<ProgramSlug, ProgramDetails> = {
  [COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG]: CAW_PROGRAM_DETAILS,
  [ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG]: ALGEBRA2_LEARNING_LABS_PROGRAM_DETAILS,
  [PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG]: PRE_CALCULUS_LEARNING_LABS_PROGRAM_DETAILS,
  [SAT_BOOTCAMP_PROGRAM_SLUG]: SAT_BOOTCAMP_PROGRAM_DETAILS,
  [DIALOGUES_PROGRAM_SLUG]: DIALOGUES_PROGRAM_DETAILS,
}

export const PROGRAM_SLUG_TO_PROGRAM_ITERATIONS: Record<
  Exclude<ProgramSlugWithIterations, 'sat-bootcamp'>,
  ProgramIteration[]
> = {
  [COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG]: Object.values(CAW_ITERATIONS),
  [ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG]: Object.values(ALGEBRA2_LEARNING_LABS_ITERATIONS),
  [PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG]: Object.values(PRE_CALCULUS_LEARNING_LABS_ITERATIONS),
  [DIALOGUES_PROGRAM_SLUG]: Object.values(DIALOGUES_ITERATIONS),
}

export const PROGRAM_SLUG_TO_PROGRAM_MARKETING_CONFIG: Record<
  ProgramSubworldSlug,
  ProgramMarketingConfig
> = {
  [COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG]: CAW_MARKETING_CONFIG,
  [ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG]: ALGEBRA2_LEARNING_LABS_MARKETING_CONFIG,
  [PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG]: PRE_CALCULUS_LEARNING_LABS_MARKETING_CONFIG,
  [SAT_BOOTCAMP_PROGRAM_SLUG]: SAT_BOOTCAMP_MARKETING_CONFIG,
  [DIALOGUES_PROGRAM_SLUG]: DIALOGUES_MARKETING_CONFIG,
}

export const PROGRAM_SLUG_TO_EMAIL_DATA: Record<
  | typeof ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG
  | typeof PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG
  | typeof COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG,
  ProgramEmailData
> = {
  [ALGEBRA2_LEARNING_LABS_PROGRAM_SLUG]: KA_LEARNING_LABS_EMAIL_DATA,
  [PRE_CALCULUS_LEARNING_LABS_PROGRAM_SLUG]: KA_LEARNING_LABS_EMAIL_DATA,
  [COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG]: CAW_EMAIL_DATA,
}

export const PROGRAM_CARD_STYLES: Partial<
  Record<
    ProgramSlug,
    {
      image: string
      primaryColor: string
      bgColor: string
    }
  >
> = {
  [SAT_BOOTCAMP_PROGRAM_SLUG]: {
    image: '/programs/program-cards/sat-bootcamp.png',
    primaryColor: 'purple.600',
    bgColor: 'purple.50',
  },
  [COLLEGE_ADMISSIONS_WORKSHOPS_PROGRAM_SLUG]: {
    image: '/programs/program-cards/caw.png',
    primaryColor: 'blue.600',
    bgColor: 'blue.100',
  },
  [DIALOGUES_PROGRAM_SLUG]: {
    image: '/programs/program-cards/dialogues.png',
    primaryColor: 'yellow.500',
    bgColor: 'yellow.100',
  },
}
